module.exports = __webpack_public_path__ + "img/cuadrado.3d80acf3.png";